import { useRSOList } from "@/api/services/admin/rso";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { ERSOContractStatus } from "@/types/enum";
import { Stack } from "@mui/material";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { IconPlus } from "@/assets/icons";
import { CountTable } from "@/components/elements/CountTable";

type TPartnerListTopProps = {
  contractStatuses: ERSOContractStatus[];
};

export const PartnerListTop: FC<TPartnerListTopProps> = ({ contractStatuses }) => {
  const { data } = useRSOList(contractStatuses);

  const contractStatus = contractStatuses.length && contractStatuses[0];
  const isEnableButtonCreate = contractStatus && [ERSOContractStatus.DURING_CONTRACT, ERSOContractStatus.TRIAL].includes(contractStatus);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CountTable total={data?.pagination.total} page={data?.pagination.page} perPage={data?.pagination.perPage} />

      {isEnableButtonCreate && (
        <Button component={Link} size="sm" to={AppRoutes.rsoCreate} startIcon={<IconPlus />}>
          新規顧客登録
        </Button>
      )}
    </Stack>
  );
};
